import { useState } from "react";
import { GeneralButton } from "../../../../common/ui/GeneralButton";
import { PropertyEditorProps } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import SelectSingleServiceModuleDialog from "../../../serviceModules/SelectSingleServiceModuleDialog";

export function SurveyAppointmentCalendarEditor(props: PropertyEditorProps) {
    const [open, setOpen] = useState(false);

    return <>
        <GeneralButton
            appVariant="secondary"
            onClick={() => setOpen(true)}>
            Kalender wählen
        </GeneralButton>
        {
            open &&
            <SelectSingleServiceModuleDialog
                onClose={() => setOpen(false)}
                moduleType="Calendar"
                selectedModule={(props.value ?? null) as number | null}
                handleOnSave={(id) => {
                    setOpen(false);
                    props.onChanged(id);
                }}
            />
        }
    </>;
}